export default __webpack_public_path__ + "_/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-stainless-500-044118bdbcd6a4350d321ee179bfeb90.svg";